import React, { useState, useEffect, Fragment } from 'react';
import {
  Button,
  Row,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Label,
  Spinner,
} from 'reactstrap';
import { Colxx } from '../../../../../../../components/common/CustomBootstrap';
import { AxiosAPI } from '../../../../../../../helpers/AxiosAPI';
import {
  gAPI_OnboardGroup_By_Id,
  putAPI_UpdateStatus_Group,
} from '../../../../../../../constants/APIs';

export default function OnBoardDetail({
  groupId,
  visible,
  toggle,
  LoadGroups,
}) {
  const [cancelVisible, setCancelVisible] = useState(false);
  const [groupData, setGroupData] = useState();
  useEffect(() => {
    AxiosAPI({
      methhod: 'get',
      url: `${gAPI_OnboardGroup_By_Id}/${groupId}
`,
    })
      .then((res) => {
        //  console.log('res.data', res.data);
        // TODO:
        setGroupData(res.data);
      })
      .catch((err) => console.log('err', err));
  }, [groupId]);

  const ApproveGroup = () => {
    let data = {
      status: 'Approved',
      Updater: 'Super Admin',
    };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_UpdateStatus_Group}/${groupId}`,
      data: data,
    })
      .then((data) => {
        LoadGroups();
        toggle();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const ArchiveGroup = () => {
    let data = {
      status: 'Archived',
      Updater: 'Super Admin',
    };
    AxiosAPI({
      method: 'put',
      url: `${putAPI_UpdateStatus_Group}/${groupId}`,
      data: data,
    })
      .then((data) => {
        LoadGroups();
        toggle();
      })
      .catch((err) => {
        console.log('err', err);
      });
  };

  const toggleCancelBooking = () => {
    setCancelVisible(!cancelVisible);
  };

  const generateArichveGroup = () => {
    return (
      <Row>
        <Colxx xs="12" sm="12" md="12" lg="8" className="mb-4">
          <Row>
            <Colxx xs="12" sm="3" className="mb-1">
              <Modal isOpen={cancelVisible} toggle={toggle}>
                <ModalHeader toggle={toggle}>
                  <span role="img" aria-label="warning">
                    ⚠️
                  </span>
                  This group will be archive!
                </ModalHeader>
                <ModalBody>
                  <Button
                    color="danger"
                    onClick={() => ArchiveGroup()}
                    size="xs"
                  >
                    Archive
                  </Button>
                  <Button
                    className="ml-2"
                    color="dark"
                    outline
                    size="xs"
                    onClick={toggleCancelBooking}
                  >
                    Back
                  </Button>
                </ModalBody>
              </Modal>
            </Colxx>
          </Row>
        </Colxx>
      </Row>
    );
  };

  return (
    <Modal isOpen={visible} toggle={() => toggle()} size="lg">
      <ModalHeader toggle={() => toggle()}>
        <div> Detail</div>
      </ModalHeader>
      <ModalBody>
        {groupData ? (
          <Fragment>
            <Row className="mb-3">
              <Colxx xxs={4} className="mb-3">
                <Label>
                  {' '}
                  <b> Name </b>
                </Label>
                <div>{groupData.name}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>Type</b>
                </Label>
                <div>{groupData.type}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>Website</b>
                </Label>
                <div>{groupData.website}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>Country</b>
                </Label>
                <div>{groupData.country}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>TimeZone</b>
                </Label>
                <div>{groupData.timeZone}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>Subscription</b>
                </Label>
                <div>{groupData.subscription}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>Promo Code</b>
                </Label>
                <div>{groupData.promoCode}</div>
              </Colxx>
            </Row>
            <h4>User</h4>
            <Row className="mb-3">
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>First Name</b>
                </Label>
                <div>{groupData.firstName}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>Last Name</b>
                </Label>
                <div>{groupData.lastName}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>Email</b>
                </Label>
                <div>{groupData.email}</div>
              </Colxx>
              <Colxx xxs={4} className="mb-3">
                <Label>
                  <b>Phone Number</b>
                </Label>
                <div>{groupData.mobileNumber}</div>
              </Colxx>{' '}
            </Row>
          </Fragment>
        ) : (
          <div style={{ textAlign: 'center' }}>
            <Spinner color="primary" className="mb-1" />
            <p>Loading Data...</p>
          </div>
        )}
      </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={() => ApproveGroup()}>
          Approve Group
        </Button>
        <Button color="secondary" onClick={() => toggleCancelBooking()}>
          Archive Group
        </Button>
      </ModalFooter>
      {generateArichveGroup()}
    </Modal>
  );
}
